import { render, staticRenderFns } from "./ExtraTaskCard.vue?vue&type=template&id=3b3c00ba&scoped=true&"
import script from "./ExtraTaskCard.vue?vue&type=script&lang=js&"
export * from "./ExtraTaskCard.vue?vue&type=script&lang=js&"
import style0 from "./ExtraTaskCard.vue?vue&type=style&index=0&id=3b3c00ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3c00ba",
  null
  
)

export default component.exports